// @ts-nocheck
import { request as requester } from 'sonata-react-components';

import type { ScheduleReportInterface } from 'sonata-static-storage/lib/schemas/scheduleReport/scheduleReport.schema';

export async function downloadZip(userId: string, downloadReportIds: string[]) {
  const response = await requester.makeRequest(
    `${taptap.config.backendUrlBase}report/reportDownloads/multiDownload/${userId}`,
    {
      method: 'GET',
      params: {
        downloadReportIds: downloadReportIds.join(',')
      },
      responseType: 'arraybuffer'
    }
  );
  return new Blob([response], { type: 'application/zip' });
}

export async function deleteReportingDownload(reportDownloadId: string, token?: Record<string, any>): Promise<void> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/reportDownloads/${reportDownloadId}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export async function deleteReportingSchedule(reportScheduleId: string, token?: Record<string, any>): Promise<void> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/scheduleReport/${reportScheduleId}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export async function updateReportingSchedule(
  reportScheduleId: string,
  schedule: Partial<ScheduleReportInterface>,
  token?: Record<string, any>
): Promise<void> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/scheduleReport/${reportScheduleId}`,
    {
      data: schedule,
      method: 'PUT'
    },
    token
  );
}

// Re-export legacy API functions — these come from the legacy platform reporting module
// and are used by components that still reference @/modules/reporting/reporting.resources
export {
  connectReportingDataWithSonataLI,
  createComment,
  createSharedReport,
  deleteComment,
  deleteShareReport,
  downloadReport,
  getCampaignsZones,
  getCartographyLevels,
  getComments,
  getContextualReportURL,
  getFootfallAttributionStats,
  getGroupOptions,
  getInsightsData,
  getLastContextualReport,
  getLogo,
  getLogoAdvertiser,
  getMultipleGeoJSONData,
  getPaginatedInsightsStats,
  getPaginatedReportingStats,
  getReportingDetailedStatsUserId,
  getReportingStatsUserId,
  getReportingStreamStatsUserId,
  getSharedReportPermissions,
  getShareReports,
  getSummaryData,
  getVariableValue,
  getZonesWithBoundingBox,
  postLogo,
  updateComment,
  updateLogoStatus,
  updateShareReportEnabled,
  updateShareReportPassword
} from './reporting.resources.legacy';
